import { render, staticRenderFns } from "./PaymentSelectSkeleton.vue?vue&type=template&id=b6bac066&scoped=true"
import script from "./PaymentSelectSkeleton.vue?vue&type=script&lang=js"
export * from "./PaymentSelectSkeleton.vue?vue&type=script&lang=js"
import style0 from "./PaymentSelectSkeleton.vue?vue&type=style&index=0&id=b6bac066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bac066",
  null
  
)

export default component.exports